import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AnswerValue, QuizProgress } from '../models';

export const quizProgressActions = createActionGroup({
    source: 'Quiz Progress',
    events: {
        'Get Progress': props<{ quizId: string }>(),
        'Get Progress Success': props<{ payload: QuizProgress }>(),
        'Get Progress Not Started': emptyProps(),
        'Get Progress Error': props<{ code: number }>(),

        'Save Answer': props<{ quizId: string; questionId: string; value: AnswerValue }>(),
        'Save Answer Success': props<{ payload: QuizProgress }>(),
        'Save Answer Error': props<{ code: number }>(),
        'Clear Saved': emptyProps(),

        Retry: props<{ quizId: string }>(),
        'Retry Success': props<{ quizId: string }>(),
        'Retry Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
